/**
 * Scoring and Card Constants for Crazy Cribbage
 */

export const RANKS = Object.freeze([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13]);

export const RANK_NAME = Object.freeze({
  1: 'A',
  2: '2',
  3: '3',
  4: '4',
  5: '5',
  6: '6',
  7: '7',
  8: '8',
  9: '9',
  10: '10',
  11: 'J',
  12: 'Q',
  13: 'K'
});

export const SUITS = Object.freeze(['S', 'H', 'D', 'C']);

export const SUIT_SYM = Object.freeze({
  S: '♠',
  H: '♥',
  D: '♦',
  C: '♣'
});

export const SUIT_NAME = Object.freeze({
  S: 'Spades',
  H: 'Hearts',
  D: 'Diamonds',
  C: 'Clubs'
});

/**
 * Returns nominal point value of a rank for counting towards 15/31 (face cards = 10, Aces = 1).
 */
export const VAL = (r) => (r >= 10 ? 10 : (r <= 0 ? 0 : r));
